import React from 'react';
import { Section } from './ui/Section';
export function ForWho() {
  const points = [{
    icon: '😔',
    title: 'Domingo por la noche sin planificar',
    desc: 'Ansiedad porque no sabes qué enseñar mañana.'
  }, {
    icon: '💸',
    title: 'Alumnos que se van por falta de método',
    desc: 'Pierdes alumnos sin entender por qué.'
  }, {
    icon: '🌙',
    title: 'Horas de sueño perdidas buscando música',
    desc: 'Buscas canciones en el último momento.'
  }];
  return <Section data-id="element-94">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-95">
        ¿Te Suena Familiar?
      </h2>
      <p className="text-center text-brand-textMuted mb-8 text-sm font-body italic max-w-2xl mx-auto" data-id="element-96">
        Si asientes con 1 o más, este sistema fue diseñado para ti.
      </p>

      <div className="max-w-3xl mx-auto grid md:grid-cols-3 gap-6" data-id="element-97">
        {points.map((point, i) => <div key={i} className="bg-white border border-brand-border rounded-xl p-6 shadow-card hover:shadow-card-hover transition-all text-center" data-id="element-98">
            <div className="text-5xl mb-3" data-id="element-99">{point.icon}</div>
            <h3 className="font-heading font-bold text-brand-subtitle mb-2 text-lg" data-id="element-100">
              {point.title}
            </h3>
            <p className="font-body text-brand-text text-sm" data-id="element-101">{point.desc}</p>
          </div>)}
      </div>
    </Section>;
}